<template>
    <v-app id="eoApp">
        <v-navigation-drawer
                v-model="categoryMenu"
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
                :width="400"
        >
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-1">
                            Layer Kategorien
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-for="category in wmsLayerCategories" :key="category"
                             @click.stop="activateCategory(category)">
                    <v-list-item-icon>
                        <v-icon>fas fa-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{category}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-navigation-drawer
                    v-model="layerMenu"
                    :width="400"
                    clipped
                    fixed
            >
                <div style="padding: 10px 10px;">
                    <v-btn text @click="layerMenu = false">
                        <v-icon left small>fas fa-arrow-left</v-icon>
                        Zurück
                    </v-btn>
                </div>
                <Menu v-on:selectedLayer="updateLayer" :layerCategory="categoryName"/>
                <template v-slot:append v-if="selectedLayer">
                    <v-divider></v-divider>
                    <v-hover>
                        <template v-slot:default="{ hover }">
                            <v-card outlined class="pa-5">
                                <img style="max-height: 200px"
                                     :src="selectedLayer.selectedStyle.LegendURL[0].OnlineResource">
                                <v-fade-transition v-if="selectedLayer.selectedStyle.LegendURL[0].size[1] > 500">
                                    <v-overlay v-if="hover" absolute>
                                        <v-icon size="100" @click="dialog.legend = true">fas fa-search-plus</v-icon>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-card>
                        </template>
                    </v-hover>
                    <v-dialog v-model="dialog.legend" width="unset">
                        <v-card class="pb-5" style="max-width: 1500px">
                            <v-card-title width="unset">Legende</v-card-title>
                            <div class="pa-5">
                                <v-img :src="selectedLayer.selectedStyle.LegendURL[0].OnlineResource"
                                       :contain="true"></v-img>
                            </div>
                        </v-card>
                    </v-dialog>
                </template>
            </v-navigation-drawer>
        </v-navigation-drawer>

        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="primary"
                dark
        >
            <v-app-bar-nav-icon @click.stop="categoryMenu = !categoryMenu"/>
            <v-toolbar-title
                    style="width: 300px"
                    class="ml-0 pl-4"
            >
                <span class="hidden-sm-and-down">AGRO-DE Viewer</span>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu
                    open-on-hover
                    close-on-content-click
                    offset-y
            >
                <template v-slot:activator="{ on }">
                    <v-btn v-if="$vuetify.breakpoint.smAndDown" class="mx-5" v-on="on" icon>
                        <v-icon>fas fa-info</v-icon>
                    </v-btn>
                    <v-btn v-else text class="mx-5" v-on="on">
                        Projekt Informationen
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                            v-for="menuPoint in menuPoints"
                            :key="menuPoint.heading"
                            @click="menuPoint.show = true"
                    >
                        <v-list-item-title>{{ menuPoint.heading }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-dialog
                    v-for="menuPoint in menuPoints"
                    :key="menuPoint.heading"
                    v-model="menuPoint.show"
                    width="800"
            >
                <div :is="menuPoint.component"/>
            </v-dialog>
            <a href="https://agro-de.info/" style="position: relative">
                <img
                        src="@/assets/agro-logo2.png"
                        alt="AGRO-DE Logo"
                        height="48"
                />
            </a>
        </v-app-bar>
        <v-content>
            <v-container
                    fluid
                    fill-height
                    class="pa-0 ma-0"
            >
                <Map/>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import Map from "@/components/home/Map";
    import Partner from "@/components/home/Partner";
    import Aim from "@/components/home/Aim";
    import Menu from "@/components/home/Menu";
    import {mapGetters} from "vuex";

    export default {
        name: "Home",
        components: {
            Map,
            Partner,
            Aim,
            Menu,
        },
        data: () => ({
            fab: null,
            menuPoints: {
                aim: {show: false, component: Aim, heading: "Über AGRO-DE"},
                partner: {show: false, component: Partner, heading: "Projektpartner"},
            },
            categoryMenu: null,
            categoryName: null,
            layerMenu: false,
            selectedLayer: null,
            dialog: {
                legend: false
            }
        }),
        methods: {
            activateCategory: function (categoryName) {
                this.categoryName = categoryName;
                this.layerMenu = true
            },
            updateLayer: function (selectedLayer) {
                this.selectedLayer = selectedLayer
            }
        },
        computed: {
            ...mapGetters("map", ["wmsLayerCategories"]),
        }
    }
</script>